module.exports = __webpack_public_path__ + "img/yahoo.f1089f09.png";